import { useLocation, useParams } from 'react-router-dom';

export type NavigationContext = 'main' | 'lead-details' | 'company-details';

interface NavigationContextData {
  context: NavigationContext;
  leadId?: string;
  companyId?: string;
  leadName?: string;
}

export function useNavigationContext(): NavigationContextData {
  const location = useLocation();
  const params = useParams();
  
  // Check if we're on a lead details page
  if (location.pathname.includes('/leads/')) {
    return {
      context: 'lead-details',
      leadId: params.id,
    };
  }
  
  // Check if we're on a company details page
  if (location.pathname.includes('/companies/')) {
    return {
      context: 'company-details',
      companyId: params.id,
    };
  }
  
  // Default to main navigation
  return {
    context: 'main',
  };
}
